import React from 'react';
import Navbar from '../navbar/Navbar';
import "./about.css";

const AboutUs = () => {
  return (
    <>
      {/* <Navbar /> */}
      <section className="min-h-screen bg-gradient-to-b from-white via-pink-50 to-orange-50 flex items-center ">
        <div className="px-6 py-10 mx-auto max-w-5xl text-center">
          
          {/* Title */}
          <h1 className="text-xl md:text-6xl font-bold text-gray-900 mb-6">
            About <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 mt-14">HappyU</span>
          </h1>
          
          <p className="text-md md:text-xl text-gray-700 mb-10 mt-10  leading-relaxed">
            We’re a group of passionate students from a government college who’ve seen how
            <span className="text-pink-500 font-semibold"> stress, anxiety, and loneliness </span>
            impact our peers every day.
            That’s why we built <span className="font-semibold text-orange-500">HappyU</span> —
            a safe, tech-powered platform that helps students track emotions, reflect through journaling,
            and take small steps toward better mental wellbeing.
          </p>

          {/* Mission Section */}
          <div className="bg-white/80 backdrop-blur-md rounded-2xl shadow-xl p-8 md:p-12 mb-10 border border-pink-100 hover:shadow-2xl transition">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Mission
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              Our mission is to make <span className="text-pink-500 font-semibold">mental health support</span> accessible
              and stigma-free. We believe every student deserves to be heard without judgement. Mental fitness is not something that should be ignored, each of us have had friends who have suffered through some type of form of mental illness. We wanted to make something that would help people deal with the inner battles they are going through.
            </p>
          </div>

          {/* Vision Section */}
          <div className="bg-gradient-to-r from-pink-100 to-orange-100 rounded-2xl shadow-lg p-8 md:p-12 mb-10 border border-orange-100 hover:shadow-2xl transition">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Vision
            </h2>
            <p className="text-gray-800 text-lg leading-relaxed">
              We envision a world — starting with our college — where mental health is talked about openly,
              and no one feels alone in their struggles. We envision a world where no one has to go through their inner battles alone, this app has been made such that this app becomes a support system for people that don't have them.
              <br /><br />
              Through <span className="text-pink-600 font-semibold">HappyU</span>, we’re building
              a culture of care, compassion, and awareness — one reflection at a time.
            </p>
          </div>

          {/* Button */}
          <div className="mt-10">
            <a
              href="/"
              className="inline-block bg-gradient-to-r from-pink-500 to-orange-400 hover:from-pink-600 hover:to-orange-500 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition"
            >
              Back to Home
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
